<template>
  <div class="contentCompEnfant">
            
      <div class="login-form" id="login-form" >
        <!--<h1>Connexion CRM</h1>-->

        <!-- <?php if (isset($message_erreur) and $message_erreur != "") {
  				echo '<div id="message" class="alert-danger">'.$message_erreur.'</div>';
  			} ?> -->
        
        <div class="txtb" id='user'>
          <input v-model="login" name='identifiant' autocomplete="new-password" placeholder=" Utilisateur" style="font-size: 11px;">
          <!--<span data-placeholder="Utilisateur"></span>-->
    
        </div>

        <div class="txtb">
          <input v-model="password" type='password' name='mdp' autocomplete="new-password" placeholder=" Mot de passe" style="font-size: 11px;">
          <!--<span data-placeholder="Mot de passe"></span>-->
        </div>
         <el-select placeholder="Veuillez selectionner une base" v-model="societe"  id='base' size='mini' name='base' filterable required >

               <el-option
                v-for="item in bases"
                :key="item.base"
                :label="item.base"
                :value="item.base">
              
              </el-option>
            </el-select>
            <br><br>
        <input type="submit" class="logbtn" name="" value="Se connecter" @click='loginMethod'></input>

      </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import axios from 'axios';
    export default {
    name: 'LoginHome',
   data() {
    return {
      value:"",
      societe:"",
    bases:[{"base":"AGS"},{"base":"AGSESPAGNA"},{"base":"AGSBENELUX"}],
      login:'',
      password:'',
    }
    },  
    computed: {
      status () {
        return this.$store.getters.status
      },
      errorLoginLocal () {
        return this.$store.getters.errorLogin
      }
    },
    watch: {
      status () {
        console.log('status')
        if (this.status == true) {
          this.$router.push({path: '/admin/home'})
        } else {
          this.$message.error(this.errorLoginLocal);
        }
      }
    },
    created(){
        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
    },
    mounted(){
        if ( $(window).height() < 450 ) {
            $('#login-form').addClass('small');
        }
        else {
            $('#login-form').removeClass('small');
        }
        
        $(".txtb input").on("focus",function(event) {
            $(this).addClass('focus');
        });

        $('.txtb input').on("blur",function() {
            if(this.value==''){
                $(this).removeClass('focus');
            }
        })
    },
    methods: {
      redirect(){
        if (this.$store.getters.status) {
          this.$router.push({path: '/admin/home'})
        }
      },
        loginMethod(){
            if (this.societe==""){
            window.alert("vous devez obligatoirement choisir une societe");
            return 0;
            } 
            
            this.$store.commit('connexion',{ 'login':this.login,'mdp':this.password,'societe':this.societe})
           
        },
        
    }
}

let body = document.getElementsByTagName("body")[0];
const div = document.createElement("div");
div.className = "img-top";
body.parentNode.appendChild(div);

  $( document ).ready(function() {
    let selectdiv = document.getElementsByClassName("el-select")[0];
    selectdiv.onclick = function(){
          let name = document.getElementsByClassName("el-scrollbar")[0];
          name.parentNode.style.top = (parseInt(name.parentNode.style.top)-20) + "px";
    };
  });
</script>
<style>
</style>